import { render } from "./GrilleHostingComponent .vue?vue&type=template&id=4f7f5856&scoped=true"
import script from "./GrilleHostingComponent .vue?vue&type=script&lang=js"
export * from "./GrilleHostingComponent .vue?vue&type=script&lang=js"

import "./GrilleHostingComponent .vue?vue&type=style&index=0&id=4f7f5856&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f7f5856"]])

export default __exports__